import { googleDriveProvider } from './providers/googleDriveProvider';
import { megaProvider } from './providers/megaProvider';

export const importProviders = [
  googleDriveProvider,
  megaProvider
];

export const getImportProvider = (providerId) =>
  importProviders.find(provider => provider.id === providerId) || null;
